import React, { useState } from 'react';

import { Controller, FormProvider, useForm, useFormState } from 'react-hook-form';

import { Input } from 'Components-redesign/Fields/New/Input';
import Field from 'Components-redesign/RHF/Field';
import { useI18n } from 'Hooks';
import ForgotPassword from 'Scenes-redesign/ForgotPassword';

import {
  ErrorMessage,
  InnerWrapper,
  InputWrapper,
  SubmitButton,
  Title,
  VisibilityIcon,
  Wrapper,
} from './styles';
import Props from './types';

type BaseFormInputs = {
  username: string;
  password: string;
};

const defaultValues: BaseFormInputs = {
  username: '',
  password: '',
};

const LoginView: React.FunctionComponent<Props> = ({ onSetField, onLogin, error, loading }) => {
  const { t } = useI18n();
  const [visible, setVisible] = useState(false);

  const methods = useForm<BaseFormInputs>({
    defaultValues,
  });

  const { watch, control, handleSubmit } = methods;

  const watchUsername = watch('username');
  const watchPassword = watch('password');

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onLogin)}>
        <Wrapper>
          <InnerWrapper>
            <Title>{t('General.Welcome')}</Title>
            <Field name="username" label={t('Register.EmailOrUsername')}>
              <Controller
                control={control}
                name="username"
                render={({ field }) => (
                  <Input
                    onChange={(e) => {
                      field.onChange(e);
                      onSetField('username', e.target.value);
                    }}
                  />
                )}
              />
            </Field>
            <Field name="password" label={t('Register.Password')}>
              <InputWrapper>
                <Controller
                  control={control}
                  name="password"
                  render={({ field }) => (
                    <Input
                      type={visible ? 'text' : 'password'}
                      onChange={(e) => {
                        field.onChange(e);
                        onSetField('password', e.target.value);
                      }}
                    />
                  )}
                />
                <VisibilityIcon isVisible={visible} onClick={() => setVisible(!visible)} />
              </InputWrapper>
            </Field>
            <ForgotPassword />
            <ErrorMessage>{error}</ErrorMessage>
            <SubmitButton type="submit" disabled={loading || !watchUsername || !watchPassword}>
              {loading ? <>{t('General.LoadingThreeDots')}</> : <span>{t('General.Login')}</span>}
            </SubmitButton>
            {/* A form where users can create an account themselves */}
            {/* <RegisterText>
              New member?
              <NavLink to="/register">
                <RegisterLinkWrapper>Create an account</RegisterLinkWrapper>
              </NavLink>
            </RegisterText> */}
          </InnerWrapper>
        </Wrapper>
      </form>
    </FormProvider>
  );
};

export default LoginView;
